import { styled } from '@mui/material/styles';
import React from 'react';

const StyledImage = styled('img')({
    maxWidth: '100%',
    '&:hover': {
        cursor: 'pointer'
    }
});

const Component = ({ alt, src }) => {
    return <StyledImage alt={alt} src={src}/>;
};

export default Component;
